import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../../reducers";
import {
  Combo2Service,
  ComboService,
  ReportService,
} from "../../../../services/index";
declare var google;

@Component({
  selector: "salesOrder",
  templateUrl: "./salesOrderReport.html",
})
export class salesOrderReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  gridOptions: any;
  data: any;
  sizeMenu = ["YES", "NO"];
  exceldata: any;
  fitList = [];
  seasonList = [];
  finyearList = [];
  seasonfinList = [];
  typeList = ["party", "agent"];
  listSelected: any = [];
  brandList = ["EXPOSE", "ARAZA", "GREEN OLIVE", "LEO BOYS", "JOB", "ALL"];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  user: any;
  //     viewType = 'GRID';
  designData: any;
  newlistSelected = [];
  agentVisible: boolean = false;
  clear: boolean = false;
  filter = {
    finyear: "",
    fin_id: "",
    season_id: "",
    season: "",
    groupby: "partywise",
    type: "agent",
    agent_id: "",
    from_date: "",
    to_date: "",
    brand : "EXPOSE",
    party_id: "",
    variety: ""
  };
  dispName = [];
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Agent Yearly report",
    columns: [],
    rows: [],
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    name: "",
    //company_id: 0
  };

  constructor(
    public store: Store<fromRootStore.State>,
    private reportService: ReportService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private combo: Combo2Service,
    public comboservice: ComboService
  ) {
    this.filter.from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
  }

  ngOnInit(): void {
    this.finyearCombo();
    // this.seasonCombo();
    this.getSeasonList();
    // this.getsalesOrderPartyReport();

    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      maxHeight: window.innerHeight - 300 + "px",
      loading: true,
      data: [],
    };
    this.designData = {
      cols: [],
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);
    // this.pageCallback({ offset: 0 });
    // this.checkuser();
  }

  // checkuser() {
  //     let that = this;

  //     if (this.user.params && !this.user.params.agent_id) {
  //         that.agentVisible = true;
  //     }

  // }

  // hotkeys(event) {
  //     if (this.active) {

  //     }
  // }

  onOpenedFilter(): void {}

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getsalesOrderPartyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  setData(data) {
    this.data = Object.assign({}, data);
  }

  // loadSeasonList() {
  //     let that = this;
  //     that.reportService.getNewSeasonList(this.filter)
  //         .then(function (res) {
  //             that.seasonList = res;
  //         });
  // }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      // that.filter.finyear = res.data[0].finyear;
      that.filter.fin_id = res.data[0].fin_id;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.onSelectFinyear(res.data[0].fin_id);
      that.getSeasonList();
    });
  }
  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getBrandNewSeason(params).then((res: any) => {
      this.seasonList = res;
      this.allseason();
      this.seasonCtrl.setValue(res[res["length"] - 1].season_id);
      this.getsalesOrderPartyReport();
    });
  }
  allseason() {
    let fin_id = parseInt(this.filter.fin_id);

    this.seasonList.forEach(() => {
      let seasonAll = {
        season: "ALL",
        season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
        fin_id: fin_id,
      };
      if (fin_id > 0) {
        this.seasonList.push(seasonAll);
      }
      fin_id = fin_id - 1;
    });
  }
  onSelectFinyear(id) {
    this.filter.season_id = "";
    var fin_id = id;
    // let seasonfinList = _.filter(this.seasonList, fin_id );
    let seasonfinList = this.seasonList.filter((res) => res.fin_id == fin_id);
    this.seasonfinList = seasonfinList;
    this.seasonCtrl.setValue(
      this.seasonfinList[this.seasonfinList["length"] - 1].season_id
    );
    this.filter.season_id = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season_id;
    this.filter.season = this.seasonfinList[
      this.seasonfinList["length"] - 1
    ].season;
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }
    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "applyFilter") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getsalesOrderPartyReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getsalesOrderPartyReport();
  }

  onCellClick(event) {
    // this.filter.type = "agentpartywise";
    let row = event.row;

    if(this.filter.type =='agent'){
      this.filter.agent_id = row.agent_id;
      this.filter.type = 'party'
   }
    else if(this.filter.type =='party'){
      this.filter.party_id = row.party_id

       this.filter.type = 'variety'
    }
    else if(this.filter.type =='variety'){
      this.filter.variety = row.type
      this.filter.type = 'design'
   }
    this.getsalesOrderPartyReport();
    // let params = {
    //     start: `${this.page.offset * (this.page.limit + 1)}`,
    //     limit: `${this.page.limit}`,
    //     page: '1',
    //     orderColumn: `${this.page.orderBy}`,
    //     orderDir: `${this.page.orderDir}`,
    //     filter: JSON.stringify(this.filter),
    //     dispName: JSON.stringify(this.dispName)
    // };
    // let that = this;

    // this.isLoadMask = this.reportService
    //     .getSalesOrderPartyReport(params)
    //     .then(function (res: any) {
    //         that.loadingIndicator = false;
    //         that.dataList = res.data;
    //         that.filter.agent_id = '';
    //         that.columns = res.columns;
    //         that.gridOptions = {
    //             columns: res.columns,
    //             cols: res.cols,
    //             data: res.data,
    //             loading: false
    //         }
    //         // if(that.filter.viewtype=='TILE'){
    //         //     that.viewType='TILE';
    //         // }else{
    //         //     that.viewType ='GRID';
    //         // }

    //         that.designData = {
    //             cols: res.cols,
    //             data: res.data
    //         }
    //         that.page.count = res.total;
    //         that.refreshData();
    //         // that.exceldata = that.getData(res.columns, res.data);
    //         //that.page.count = res.total;
    //         //that.refreshData();
    //         // that.printConfig = {
    //         //     title: 'Sales Order report',
    //         //     columns: that.gridOptions.columns,
    //         //     rows: that.gridOptions.data
    //         // };
    //         //  that.columns = res.columns;
    //     });
  }

  onbackbutton() {
    // this.filter.groupby = "partywise";
    if (this.filter.type == "party") {
      this.filter.type = "agent";
      this.filter.agent_id = "";
    }
    else if(this.filter.type=="variety"){
      this.filter.type = "party";
      this.filter.party_id = "";
    }
    else if(this.filter.type=="design"){
      this.filter.type = "variety";
      this.filter.variety = "";
    }
    this.getsalesOrderPartyReport();
  }

  onClickColor(event) {
    let tabObj = {};
    this.clear = true;
    let chkData = this.clear;
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ORDER_REPORTS",
        title: "ORDER REPORT",
        tabParent: "REPORTS",
        data: event.row,
        chkData: chkData,
        name: "DesignWiseSalesOrderReport",
      },
    };

    this.tabUpdateEvent.emit(tabObj);
  }

  getsalesOrderPartyReport(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
  
    // let filter = Object.assign({}, this.filter);

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      dispName: JSON.stringify(this.dispName),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getSalesOrderPartyReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.dataList = res.data;
        that.columns = res.columns;
        that.gridOptions = {
          columns: res.columns,
          cols: res.cols,
          data: res.data,
          loading: false,
        };
        // if(that.filter.viewtype=='TILE'){
        //     that.viewType='TILE';
        // }else{
        //     that.viewType ='GRID';
        // }

        that.designData = {
          cols: res.cols,
          data: res.data,
        };
        that.page.count = res.total;
        that.refreshData();
        // that.exceldata = that.getData(res.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        // that.printConfig = {
        //     title: 'Sales Order report',
        //     columns: that.gridOptions.columns,
        //     rows: that.gridOptions.data
        // };
        //  that.columns = res.columns;
      });
  }

  //     exportToExcel($event) {
  //         this.excelService.exportAsExcelFile(this.exceldata, this.title);

  //     }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.filterData = {
      name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    //this.filterPanel.close();
    // this.viewType = 'GRID';
    this.filter.groupby = "partywise";
    this.getsalesOrderPartyReport();
    // this.filter['design_no'] = '';
  }

  displaySeason(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }

  onRowSelected($event) {
    let data = Object.assign($event.selected[0]);
    //  data['fin_id'] = this.filter.fin_id;
    const tabObj = {
      action: "NewTab",
      params: {
        tabParent: "REPORTS",
        tabName: "PartySalesOrderReport",
        type: "order",
        mode: "View",
        data: data,
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList;
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/salesOrderReport/salesOrderReport.ts